var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldCheck = function SvgShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 5.22c-4.36 0-8.814-2.93-8.857-2.959a.44.44 0 0 0-.486 0c-.045.03-4.497 2.96-8.857 2.96a.44.44 0 0 0-.438.437v6.066c0 9.263 9.25 13.994 9.342 14.042a.44.44 0 0 0 .392 0c.093-.046 9.341-4.778 9.341-14.04V5.657a.436.436 0 0 0-.437-.437m-3.669 5.257-6.067 6.067a.876.876 0 0 1-1.238 0l-3.033-3.033a.875.875 0 0 1 1.237-1.238l2.415 2.415 5.448-5.448a.875.875 0 0 1 1.238 1.237"
  })));
};
export default SvgShieldCheck;